import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { url, routes } from "oo-routes";

import "./styles";

const IMAGES = [
  {
    src: require("./top-left.jpg"),
    alt: "top_left_img",
  },
  {
    src: require("./top-right.jpg"),
    alt: "top_right_img",
  },
  {
    src: require("./bottom-left.jpg"),
    alt: "bottom_left_img",
  },
  {
    src: require("./bottom-right.jpg"),
    alt: "bottom_right_img",
  },
];

export default class Technology extends React.Component {
  static propTypes = {};

  state = {};

  render() {
    return (
      <div className="Technology">
        <div className="ui divider section-border m-v-0 computer-only" />
        <div className="p-v-2 computer-only" />
        <div className="p-v-2 computer-only" />
        <div className="p-v-2 computer-only" />
        <div className="ui container">
          <div className="ui tablet vertically reversed mobile vertically reversed grid">
            <div className="six wide computer twelve wide tablet computer-only tablet-only column">
              <div className="ui two column stackable grid">
                {_.map(IMAGES, (image, index) => (
                  <div className="column" key={index}>
                    <div className="image-container">
                      <img src={image.src} alt={image.alt} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="computer only column" />
            <div className="five wide computer twelve wide tablet column">
              <div className="text center-aligned-m center-aligned-t">
                <h1 className="m-b-2">FUELED BY TECHNOLOGY</h1>
                <div className="p-b-0_5" />
                <div className="m-b-1 fs-3">
                  We believe that software and automation is the future of the
                  mass customization industry. Our technology team is globally
                  distributed and builds technology that enables us to operate
                  faster and more efficiently than anybody else in the market.
                </div>
                {/*
                update 6/17/2024: hidden due to inactive eng blog
                <div className="fs-3">
                  <a href="https://eng.scalablepress.com/">
                    Learn more about our technology
                  </a>
                </div>
                */}
              </div>
            </div>
          </div>
        </div>
        <div className="p-v-2 computer-only" />
        <div className="p-v-2 computer-only" />
        <div className="p-v-2" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/HomePage2/Technology/index.jsx